/**
 * Lo último que eligió cada persona en la ventana del recibo (2026-10-07).
 *
 * Lo pidió el dueño con la ventana de una venta delante: «que quede guardada
 * las últimas opciones del usuario allí». El papel (rollo de 80, de 58 u hoja
 * carta), la moneda y el código de cada producto (SKU, código de barras o
 * ninguno).
 *
 * ⚠️ ANTES SE «GUARDABAN» Y NO SE GUARDABA NADA. El papel y la moneda se
 * mandaban a `PATCH /tenant` dentro de `settings`, una ruta que no acepta
 * ajustes —los ignoraba en silencio— y que además pide permiso para configurar
 * el negocio, que un cajero no tiene. Por eso en la ventana nunca salía marcado
 * el papel aunque se eligiera cada vez.
 *
 * Ahora se guardan en ESTE aparato y para ESTA persona: es una comodidad suya,
 * funciona sin internet y sin permisos, y en una caja compartida cada cajero
 * encuentra lo suyo. Lo del negocio (Ajustes → Impresora) sigue siendo lo de
 * fábrica mientras la persona no haya elegido nada.
 */

import type { FormatoDeHoja } from "@/lib/imprimirHoja";

/** Qué código va junto a cada producto en el papel. */
export type CodigoEnRecibo = "sku" | "barcode" | "ninguno";

export type PreferenciasDelRecibo = {
  formato?: FormatoDeHoja;
  moneda?: string;
  codigo?: CodigoEnRecibo;
};

function llave(negocio: string, usuario: string): string {
  return `softfi-recibo:${negocio}:${usuario}`;
}

export function leerPreferencias(negocio?: string | null, usuario?: string | null): PreferenciasDelRecibo {
  if (!negocio || !usuario) return {};
  try {
    const guardado = JSON.parse(localStorage.getItem(llave(negocio, usuario)) ?? "null") as PreferenciasDelRecibo | null;
    return guardado && typeof guardado === "object" ? guardado : {};
  } catch {
    // Modo privado o algo roto: la ventana funciona igual, sin recordar.
    return {};
  }
}

export function guardarPreferencia(
  negocio: string | null | undefined,
  usuario: string | null | undefined,
  cambio: PreferenciasDelRecibo,
): void {
  if (!negocio || !usuario) return;
  try {
    const actual = leerPreferencias(negocio, usuario);
    localStorage.setItem(llave(negocio, usuario), JSON.stringify({ ...actual, ...cambio }));
  } catch {
    /* sin memoria en el aparato: se elige cada vez */
  }
}
